import React from "react";
import {
  useCreateProjectPortfolio,
  useRetrieveCurrentPlanzone,
  useRetrieveProjectPortfolios,
} from "@planzone/view-models";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import { ProjectPortfolio } from "./projectPortfolio";
import styles from "./styles.scss";

function PortfolioAssignation({ selectedPortfolios, addPortfolios }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const { portfolios } = useRetrieveProjectPortfolios();
  const { isRequestPending, createProjectPortfolio } =
    useCreateProjectPortfolio();
  const [search, setSearch] = React.useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const filteredPortfolios = portfolios.filter(
    (portfolios) =>
      selectedPortfolios.findIndex((p) => p.uuid === portfolios.uuid) === -1,
  );

  return (
    <div className={styles.portfolioAssignation}>
      <div className={styles.search}>
        <input
          value={search}
          className={styles.input}
          placeholder={t("portfolioAssignation.search")}
          onChange={({ target }) => setSearch(target.value)}
        />
      </div>
      <ul className={styles.list}>
        {filteredPortfolios.map((portfolio) => (
          <li key={portfolio.uuid} className={styles.item}>
            <ProjectPortfolio
              portfolio={portfolio}
              addPortfolios={addPortfolios}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}

export { PortfolioAssignation };
